export default "__VITE_ASSET__BW7$6xFK__"